import type { Solutions2Package } from "app/common/services/solutions2Helper";
import { hasAccessToPackage, hasAccessToState } from "app/common/services/solutions2Helper";
import type { NavigatorType } from "single-spa/react-app/ProNavigator";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import type { prioritizedTransitionHookFn } from "./redirectPipe";

type solutionGeneration = "salesIntelligence" | "workspace" | "digitalsuite";

/**
 * In case the user is trying to navigate to a state that belongs to a package which the user has no access to
 * (say, a state that belongs to market research/digital marketing package)
 * try to reroute the state to an aquivalent state in a package that the user HAS access to.
 */
// TODO: check for access in specific order and not by order of entries
const getFallbackState = (
    toState: IRouterState,
    fallbackStates: Partial<Record<solutionGeneration, string>>,
    navigator: NavigatorType,
) => {
    let fallbackState;
    let currentState = toState;
    while (!fallbackState && currentState) {
        for (const [statePackage, stateName] of Object.entries(fallbackStates)) {
            const canAccess = hasAccessToPackage(statePackage as Solutions2Package);
            if (canAccess) {
                fallbackState = stateName;
            }
        }
        // @ts-ignore FIXME: strict migration - Argument of type 'string | undefined' is not assignable to parameter of type 'string'
        currentState = navigator.getState(currentState.parent);
    }

    return fallbackState;
};

/**
 * In case the user is trying to navigate to a state that belongs to a package which the user has no access to
 * (say, a state that belongs to aquisitionIntelligence/marketingIntelligence package)
 * try to reroute the state to an aquivalent state in a package that the user HAS access to.
 */
export const fallback = (fallbacks: Partial<Record<solutionGeneration, string>>): prioritizedTransitionHookFn => {
    return (transition) => {
        const toState = transition.to() as unknown as IRouterState;
        if (!hasAccessToState(toState, proNavigator)) {
            const fallbackState = getFallbackState(toState, fallbacks, proNavigator);
            return fallbackState;
        }
    };
};
